import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../loader';


@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<unknown>[] = [];

  constructor(private readonly loaderService: LoaderService) { }

  removeRequest(req: HttpRequest<unknown>): void {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (this.loaderService.isShowFullPageLoader) {
      this.requests.push(request);
      this.loaderService.isLoading.next(true);
    }

    return new Observable(observer => {
      const subscription = next.handle(request)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(request);
              observer.next(event);
            }
          },
          error => {
            this.removeRequest(request);
            observer.error(error);
          },
          () => {
            this.removeRequest(request);
            observer.complete();
          }
        );
      return () => {
        this.removeRequest(request);
        subscription.unsubscribe();
      }
    });
  }
}
